import { render, staticRenderFns } from "./CharacterIconEditor.vue?vue&type=template&id=02da3c35&lang=pug&"
import script from "./CharacterIconEditor.vue?vue&type=script&lang=ts&"
export * from "./CharacterIconEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "CharacterIconEditor.vue"
export default component.exports